var map = {
	"./bash": 1534,
	"./java": 1535,
	"./json": 1536,
	"./julia": 1537,
	"./python": 1538,
	"./r": 1539,
	"./rust": 1540,
	"./scala": 1541,
	"./shell": 1542,
	"./sql": 1543,
	"./xml": 1544,
	"./yaml": 1545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1533;